import styled from 'styled-components';

export const ButtonContainer = styled.button`
    
    --color-primary: #000;

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 3.7rem;
    // min-width: 14rem;

    font-size: 1.4rem;
    font-weight: bold;
    padding: 0 3.7rem;

    background: var(--color-primary);
    box-shadow: 0 0 0 1px var(--color-primary);
    color: #fff;
    border-radius: 5rem;

    transition: .3s;
    overflow: hidden;

    a {
        position: absolute;
        height: 100%;
        width: 100%;
    }

    & + .button {
        margin-left: 1rem;
    }

    &.outline {
        background: transparent;
        color: var(--color-primary);
    }

    @media (max-width: 540px) {
        height: 9.16667vw;
        font-size: 3.33333vw;
        padding: 0 8.33333vw;
        border-radius: 13.88889vw;

        & + .button {
            margin-left: 2.77778vw;
        }
    }
`;
